import React, { useEffect, useState } from "react";
import { Link as LinkRRD } from "react-router-dom";
import BlockIcon from "@mui/icons-material/Block";
import DoneIcon from "@mui/icons-material/Done";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import SearchIcon from "@mui/icons-material/Search";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  Breadcrumbs,
  Button,
  Card,
  IconButton,
  Link,
  Paper,
  TextField,
  Typography,
  MenuItem,
  Menu,
  Tooltip,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Helmet } from "react-helmet-async";
import moment from "moment";
import InputBase from "@mui/material/InputBase";
import { useDispatch, useSelector } from "react-redux";

import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import SnackBarUI from "../../comman/SnackBarUI";
import Appbar from "../../components/Appbar";
import { dateFormatStartFun } from "../../helper/dateConverter";
import Body from "../../layout/Body";
import { getUserAction } from "../../redux/toolkit/users/getAdminSupports";
// import BlockUnBlockAdmin from './BlockUnBlockAdmin'

import { useStyles } from "../../theme/theme";
import { getAllVoucherAction } from "../../redux/toolkit/vouchers/allVouchers";
import AreYouSureDailogUi from "../../comman/AreYouSureDailogUi";
import {
  addVoucherInStoreAction,
  addVoucherInStoreReducer,
} from "../../redux/toolkit/vouchers/addVoucherInStore";

let user_id = null;

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/allVouchers"
      >
        Voucher
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h5">
      Vouchers
    </Typography>
  </Stack>
);

const AllVoucher = () => {
  const dispatch = useDispatch();
  const allVoucherData = useSelector((state) => state.allVouchers);
  let { data, loading, total } = allVoucherData;
  const [open, setOpen] = useState(false);
  const [store, setStore] = useState({});
  //   console.log("open ====================>", open);

  //   console.log("store============================>", store);

  const storeResponse = useSelector((state) => state.addVoucherInStore);

  const { status, message } = storeResponse;

  const [snack, setSnack] = useState(false);
  const classes = useStyles();
  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });

  const adminColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      maxWidth: 50,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        // const { page, pageSize } = pageState;
        // const serialNumber =
        //   page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        // return serialNumber;

        const { page, pageSize } = pageState;
        const sku = params.row.sku;
        const index = params.api.getRowIndex(sku) + 1;
        return page * pageSize + index + 1;
      },
    },
    {
      field: "category_id",
      headerName: "Category Id",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 300,
      renderCell: (params) => {
        return (
          <LinkRRD>
            <Typography color="primary">{params?.row?.category_id}</Typography>
          </LinkRRD>
        );
      },
    },

    {
      field: "product_sku",
      headerName: "Product Sku Id",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 300,
      renderCell: (params) => {
        return (
          <LinkRRD>
            <Typography color="primary">{params?.row?.product_sku}</Typography>
          </LinkRRD>
        );
      },
    },

    {
      field: "order_failed_limit",
      headerName: "Order Failed Limit",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 300,
      renderCell: (params) => {
        return (
          <LinkRRD>
            <Typography color="primary">
              {params?.row?.order_failed_limit}
            </Typography>
          </LinkRRD>
        );
      },
    },

    {
      field: "name",
      headerName: "Name",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 300,
      renderCell: (params) => {
        return (
          <LinkRRD>
            <Typography color="primary">{params?.row?.name}</Typography>
          </LinkRRD>
        );
      },
    },

    // {
    //   field: "image",
    //   headerName: "Image",
    //   flex: 1,
    //   headerClassName: "super-app-theme--header",
    //   minWidth: 300,
    //   renderCell: (params) => {
    //     const imageUrl = params?.row?.image;
    //     return (
    //       //   <LinkRRD >
    //       <img
    //         src={imageUrl}
    //         alt="Thumbnail"
    //         style={{
    //           width: 60,
    //           height: 60,
    //           objectFit: "cover",
    //           borderRadius: 6,
    //         }}
    //       />
    //       //   </LinkRRD>
    //     );
    //   },
    // },

    {
      field: "updated_at",
      headerName: "updated_at",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 300,
      renderCell: (params) => {
        return (
          <Typography color="primary">{params?.row?.updated_at ? moment(params?.row?.updated_at).local().format("YYYY:MM:DD hh:mm:ss") : "---"}</Typography>
        );
      },
    },

    // {
    //   field: "description",
    //   headerName: "description",
    //   flex: 1,
    //   headerClassName: "super-app-theme--header",
    //   minWidth: 300,
    //   renderCell: (params) => {
    //     return (
    //       <LinkRRD>
    //         <Typography color="primary">{params?.row?.description}</Typography>
    //       </LinkRRD>
    //     );
    //   },
    // },

    // {
    //   field: "how_to_use_desc",
    //   headerName: "how_to_use_desc",
    //   flex: 1,
    //   headerClassName: "super-app-theme--header",
    //   minWidth: 300,
    //   renderCell: (params) => {
    //     return (
    //       <LinkRRD>
    //         <Typography color="primary">
    //           {params?.row?.how_to_use_desc}
    //         </Typography>
    //       </LinkRRD>
    //     );
    //   },
    // },

    {
      field: "how_to_use_points",
      headerName: "How To Use Points",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 350,
      renderCell: (params) => {
        const points = params?.row?.how_to_use_points || [];
        return (
          <Box>
            {points.map((item, index) => (
              <Tooltip
                title={item}
                sx={{
                  maxWidth: "300px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                <Typography key={index} variant="body2" color="primary">
                  • {item}
                </Typography>
              </Tooltip>

            ))}
          </Box>
        );
      },
    },

    {
      field: "country",
      headerName: "country Id",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 300,
      renderCell: (params) => {
        return <Typography color="primary">{params?.row?.country}</Typography>;
      },
    },

    {
      field: "price",
      headerName: "Price",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <>
            <Stack>
              {params?.row?.price?.denominations?.map((price, idx) => {
                return (
                  <Typography key={params.row._id + "_" + idx}>
                    {price}
                  </Typography>
                );
              })}
            </Stack>
          </>
        );
      },
    },

    {
      field: "add_in_store",
      headerName: "Add In Store",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => {
              setStore(params?.row);
              setOpen(true);
            }}
          >
            Add
          </Button>
        );
      },
    },
  ];

  const handAddStore = () => {
    console.log("adding voucher in store");
    setOpen(false);
    let data = {
      sku: store.sku,
      name: store.name,
      price: store.price, // { price, type, min, max, denominations }
      how_to_use_desc: store.how_to_use_desc,
      how_to_use_points: store.how_to_use_points,
      description: store.description,
      image: store.image, // { thumbnail, mobile, base, small }
      outer_color: store.outer_color,
      is_active: store.is_active,
    };

    dispatch(addVoucherInStoreAction(data));
    setSnack(true);

  };


  // useEffec
  useEffect(() => {
    dispatch(getAllVoucherAction());
  }, [dispatch,]);

  return (
    <>
      <Helmet>
        <title>All Vouchers</title>
      </Helmet>

      <Appbar breadcrumb={breadcrumb} />

      <Body>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
        ></Stack>

        <Card sx={{ my: 2 }}>
          <Paper
            sx={{
              bgcolor: "#fff",
              "& .super-app-theme--header": {
                bgcolor: "#071D45",
                color: "#fff",
              },
            }}
            elevation={0}
          >
            <DataGrid
              className={classes.root}
              getRowHeight={() => "auto"}
              sx={{ border: 0 }}
              rows={data}
              autoHeight
              columns={adminColumns}
              getRowId={(row) => row.sku}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              pagination
              // pageSize={pageSize}
              // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[25, 5, 100]}
              disableColumnSelector
              loading={loading ? <LoadingUI /> : false}
              components={{
                NoRowsOverlay: () => <NoDataFound />,
                Toolbar: GridToolbar,
              }}
              rowCount={total}
              paginationModel={setPageState}
              page={pageState.page}
              pageSize={pageState.pageSize}
              paginationMode="server"
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...old, page: newPage }));
              }}
              onPageSizeChange={(newPageSize) =>
                setPageState((old) => ({ ...old, pageSize: newPageSize }))
              }
            />
          </Paper>
        </Card>
      </Body>

      {open && (
        <AreYouSureDailogUi
          message={"Are You Sure You Want To Add The Voucher InTo Store"}
          state={open}
          setState={setOpen}
          handleClick={handAddStore}
        />
      )}

      <SnackBarUI
        state={snack}
        setState={setSnack}
        status={status}
        message={message}
      />
    </>
  );
};

export default AllVoucher;
